import { NextPage } from "next"
import HeaderStatic from "components/headerStatic"
import IsLoading from "containers/isLoading"
import styles from './loadingPage.module.scss'
import Subtitle from "componentsUnits/subtitle"
import { Type } from "types/type"
import Break from "componentsUnits/break"
import Button from "componentsUnits/button"
import { useRouter } from "next/navigation"
import { Size } from "types/size"

interface Props {
  children?: JSX.Element
  title?: string
  text?: string
  isLoading?: boolean
  showGoHomeButton?: boolean
  button?: {
    text: string
    onClick: () => void
  }
}


const StatusPage: NextPage<Props> = (props: Props) => {
  const router = useRouter();
  const goHome = () => {
    router.push('/home')
  }

  return <div className={styles.container}>
    <HeaderStatic text={props.title ?? 'brizup'} disableBack />
    <Break />
    <Subtitle text={props.text ?? 'brizup'} type={Type.t1} />
    <Break />
    {props.isLoading && <IsLoading />}
    {props.showGoHomeButton && <Button size={Size.xSmall} type={"1"} onClick={goHome} text="Go to the home page" />}
    {props.button && <Button size={Size.xSmall} type={"1"} onClick={props.button.onClick} text={props.button.text} />}
  </div>
}

export default StatusPage